import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DragDropFilesComponent } from 'src/app/fragments/drag-drop-files/drag-drop-files.component';
import { ProgressBarComponent } from "../../../../fragments/progress-bar/progress-bar.component";
import { RfebmPrimaryButtonComponent } from 'src/app/ui/atoms/rfebm-primary-button/rfebm-primary-button.component';
import { VideosUploadService, VideoMetadata, VideoUploadProgress } from '../../controller/video-upload.service';
import { FilterModel } from 'src/app/features/handball/video-quering/model/filter-model';

@Component({
  selector: 'app-video-upload',
  templateUrl: './video-upload.component.html',
  styleUrls: ['./video-upload.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DragDropFilesComponent,
    ProgressBarComponent,
    RfebmPrimaryButtonComponent,
    ReactiveFormsModule
  ],
})
export class VideoUploadComponent {

  @Input() filterValues: FilterModel = null;

  isUploading: boolean = false;
  uploadProgress: number = 0;
  uploadTitle: string = 'Tu video se está subiendo';
  uploadSubtitle: string = 'Por favor no cierres esta pestaña';

  uploadForm: FormGroup;
  selectedFile: File | null = null;
  errorMessage: string | null = null;

  wantedFilterValues: string[] = [
    "gender",
    "category",
    "competition",
    "championship",
  ];

  constructor(
    private VideosUploadService: VideosUploadService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.uploadForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.minLength(3)]],
      description: ['', Validators.required],
    });
  }

  onFileSelected(files: File[]) {
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.errorMessage = null;
    }
  }

  async onUploadButtonClick() {

    // Validate the form first
    if (this.uploadForm.invalid) {
      this.errorMessage = 'Por favor, completa todos los campos requeridos.';
      return;
    }

    // Check if a file is selected
    if (!this.selectedFile) {
      this.errorMessage = 'Por favor, selecciona un archivo de video para subir.';
      return;
    }

    this.isUploading = true;
    this.uploadProgress = 0;
    this.errorMessage = null;

    console.log(this.filterValues);
    console.log(this.uploadForm);

    try {
      // Prepare metadata from form
      const metadata: VideoMetadata = {
        title: this.uploadForm.get('title')?.value,
        description: this.uploadForm.get('description')?.value,
        // Add other metadata fields that might be passed from parent components
      };

      for (const key in this.filterValues) {
        if (this.wantedFilterValues.includes(key) && this.filterValues[key]) {
          metadata[key] = this.filterValues[key];
        }
      }

      console.log('Metadata to upload:', metadata);

      // Upload the video and track progress
      const videoId = await this.VideosUploadService.uploadVideo(
        this.selectedFile,
        metadata,
        (progress: VideoUploadProgress) => {
          this.uploadProgress = progress.progress;
          this.uploadTitle = progress.message || 'Subiendo video...';

          if (progress.status === 'error') {
            this.errorMessage = progress.message;
            this.isUploading = false;
          }
        }
      );

      // Upload successful
      this.uploadTitle = 'Video subido con éxito';
      this.uploadProgress = 100;

      // Wait a moment to show the success message, then navigate to watch page
      // setTimeout(() => {
      //   this.isUploading = false;
      //   this.router.navigate(['/watch', videoId]);
      // }, 3000);

    } catch (error) {
      console.error('Upload error:', error);
      this.isUploading = false;
      this.errorMessage = 'Error al subir el video. Por favor, inténtalo de nuevo.';
    }
  }
}
